<template>
  <div style="width:100%;">
    <v-container pa-0 fluid class="elevation-2 rounded-3" style="background-color:white">
      <v-flex>
        <v-tabs
          v-if="existingCaseType"
          v-model="configModel"
          grow show-arrows color="white"
          slider-color="primary" ref="tabs">
          <v-tab ripple v-for="item in items" :key="item.name" @click="handleClick(item)">{{ item.name }}</v-tab>
          <v-tab-item v-for="item in items" :key="item.name+'-content'">
            <v-divider></v-divider>
            <v-container fluid>
              <v-layout row wrap>
                <v-flex xs12 px-4 pt-3 pb-1 mb-0>
                  <component
                    :is="item.component" :caseType="caseType"
                    v-on:update-summary-data="handleSummaryUpdate"
                    v-on:update-summary-field-data="handleSummaryFieldUpdates"
                    v-on:update-data="handleUpdate"
                    v-on:reindex-cases="toggleReindexCasesDialog(true)"
                    v-on:reindex-documents="toggleReindexDocumentsDialog(true)"/>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
        </v-tabs>
        <v-container v-if="!existingCaseType" fluid>
          <v-layout row wrap>
            <v-flex xs12 px-4 pt-3 pb-1 mb-0>
              <CaseConfigSummary
                :caseType="caseType"
                v-on:update-summary-data="handleSummaryUpdate"
                v-on:update-data="handleUpdate"/>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-container>
    <v-layout row fluid wrap>
      <v-btn color="error" @click="cancelNewTemplate()" class="mt-4 ml-0" dark v-if="!existingCaseType">
        Cancel
      </v-btn>
      <v-btn color="error" @click="dialogDelete = true" class="mt-4 ml-0" dark v-if="existingCaseType">
        <v-icon>delete</v-icon>&emsp;Delete Template
      </v-btn>
      <v-dialog v-model="dialogDelete" max-width="500">
        <v-card class="pa-4">
          <v-card-title class="pa-0 pb-2">
            <h2>Are you sure you want to delete this template?</h2>
          </v-card-title>
          <v-card-text class="pa-0">
            <p>Deleting this case type will also remove all the data associated with it. Are you sure you want to do this?</p>
          </v-card-text>
          <v-card-actions class="ma-0 pa-0 pt-1">
            <v-btn @click="deleteCaseType()" color="error">Yes, delete this template</v-btn>
            <v-btn @click="dialogDelete = false" color="secondary">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <confirmation-dialog
        title="Reindex Cases"
        :message="reindexCasesMessage"
        confirmButtonLabel="Reindex Cases"
        :showDialog="showReindexCasesDialog"
        v-on:confirm="reindexCases()"
        v-on:cancel="toggleReindexCasesDialog(false)">
      </confirmation-dialog>
      <confirmation-dialog
        title="Reindex Documents"
        :message="reindexDocumentsMessage"
        confirmButtonLabel="Reindex Documents"
        :showDialog="showReindexDocumentsDialog"
        v-on:confirm="reindexDocuments()"
        v-on:cancel="toggleReindexDocumentsDialog(false)">
      </confirmation-dialog>
      <v-spacer></v-spacer>
        <v-btn
        v-if="!existingCaseType"
        @click="createCaseType()"
        class="mt-4 mb-0 mx-0"
        color="success"
        style="float:right">
        Create Template
      </v-btn>
      <v-btn
        v-if="existingCaseType"
        :disabled="!hasChanged"
        @click="saveCaseType()"
        class="mt-4 mb-0 mx-0"
        color="success"
        style="float:right">
        Save changes
      </v-btn>
      <v-dialog v-model="dialogSaveAll" max-width="500">
        <v-card class="pa-4">
          <v-card-title class="pa-0 pb-2">
            <h2>You are about to save changes to all existing cases</h2>
          </v-card-title>
          <v-card-actions class="ma-0 pa-0">
            <v-layout fluid row wrap>
              <v-btn @click="performSave()" color="success">Confirm Save</v-btn>
              <v-btn @click="dialogSaveAll = false" color="error">Cancel</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogSaveThis" max-width="500">
        <v-card class="pa-4">
          <v-card-title class="pa-0 pb-2">
            <h2>You are about to save changes to just this case.</h2>
          </v-card-title>
          <v-card-text class="pa-0">
            <p>You have un-toggled the option to save your changes to all cases that use this template. If this is what you want to do then just confirm below.</p>
          </v-card-text>
          <v-card-actions class="ma-0 pa-0">
            <v-layout fluid row wrap>
              <v-flex xs12>
                <v-checkbox
                  v-model="skipSaveWarning"
                  class="ma-0 pa-0"
                  color="secondary"
                  style="margin-bottom: -5px !important"
                  label="I understand, don't show me this dialog again when saving.">
                </v-checkbox>
              </v-flex>
              <v-btn @click="performSave()" color="success">Confirm Save</v-btn>
              <v-btn @click="dialogSaveThis = false" color="error">Cancel</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout align-baseline xs12 md4 px-2 right>
      <v-snackbar v-model="showTaskResult" :bottom="true" :right="true">
        {{taskResult.message}}
        <v-btn
          :color="((taskResult.error) ? 'error' : 'success')"
          flat
          @click="showTaskResult = false">
          Close
        </v-btn>
      </v-snackbar>
    </v-layout>
  </div>
</template>

<script>
import "@/assets/styles/styles.css"
import CaseConfigSummary from "@/components/cases/case-config/CaseConfigSummary.vue"
import CaseConfigTasks from "@/components/cases/case-config/CaseConfigTasks.vue"
import CaseConfigStatus from "@/components/cases/case-config/CaseConfigStatus.vue"
import CaseConfigSchema from "@/components/cases/case-config/CaseConfigSchema.vue"
import CaseConfigRelationships from "@/components/cases/case-config/CaseConfigRelationships.vue"
import CaseConfigPermissions from "@/components/cases/case-config/CaseConfigPermissions.vue"
import CaseConfigDocuments from "@/components/cases/case-config/CaseConfigDocuments.vue"
import CaseConfigEmails from "@/components/cases/case-config/CaseConfigEmails.vue"
import CaseConfigScripts from "@/components/cases/case-config/CaseConfigScripts.vue"
import ConfirmationDialog from "@/components/shared/ConfirmationDialog.vue"
import { mapState } from "vuex"
import Helpers from "@/helpers.js"

export default {
  name: "case-config",
  components: {
    CaseConfigSummary,
    CaseConfigTasks,
    CaseConfigStatus,
    CaseConfigSchema,
    CaseConfigRelationships,
    CaseConfigPermissions,
    CaseConfigDocuments,
    CaseConfigScripts,
    CaseConfigEmails,
    ConfirmationDialog
  },
  props: { caseType: { type: Object, required: true } },
  data: () => ({
    hasChanged: false,
    newSummaryData: {},
    newTasksData: {},
    newStatusData: {},
    newSchemaData: {},
    newRelationsData: {},
    newPermissionsData: {},
    newDisplayFields: null,
    caseTypeUpdates: {},
    skipSaveWarning: false,
    showTaskResult: false,
    shouldUpdateExisting: true,
    dialogSaveAll: false,
    dialogSaveThis: false,
    dialogDelete: false,
    showReindexCasesDialog: false,
    showReindexDocumentsDialog: false,
    configModel: 0,
    localUpdate: false
  }),
  computed: {
    existingCaseType() {
      return this.caseType && this.caseType.id !== undefined && this.caseType.id !== null
    },
    items() {
      let items = [
        { name: "Summary", title: "Case Summary", component: "CaseConfigSummary" },
        { name: "Schema", title: "Schema", component: "CaseConfigSchema" }
      ]
      if (this.existingCaseType) {
        items = items.concat([
          { name: "Tasks", title: "Tasks", component: "CaseConfigTasks", class: "updated" },
          { name: "Status", title: "Tasks", component: "CaseConfigStatus" },
          { name: "Relationships", title: "Relationships", component: "CaseConfigRelationships", class: "updated" },
          { name: "Scripts", title: "Scripts", component: "CaseConfigScripts", class: "updated" },
          { name: "Email Templates", title: "Emails", component: "CaseConfigEmails" },
          { name: "Permissions", title: "Permissions", component: "CaseConfigPermissions" },
          { name: "Documents", title: "Documents", component: "CaseConfigDocuments" }
        ])
      }
      return items
    },
    ...mapState({
      taskRunning: state => state.currentUser.taskRunning,
      taskResult: state => state.currentUser.taskResult,
      configTab: state => state.cbroute.params.config_tab,
      caseTypeId: state => state.cbroute.params.case_type_id,
      isAccountAdmin: state => state.currentUser && state.currentUser.isAccountAdmin
    }),
    isAppAdmin() {
      return !!this.isAccountAdmin
    },
    reindexCasesMessage() {
      const name = this.caseType && this.caseType.name ? this.caseType.name : "this template"
      return "Rebuild the search index for cases on " + name + ". Existing indexed cases for this template will be replaced. Search results may be incomplete until the job finishes."
    },
    reindexDocumentsMessage() {
      const name = this.caseType && this.caseType.name ? this.caseType.name : "this template"
      return "Extract text from files on " + name + " and index them for search. Existing indexed documents for this template will be replaced."
    }
  },
  created() {
    this.handleRouteChange(this.configTab)
  },
  watch: {
    configTab() {
      this.localUpdate = false
      this.handleRouteChange(this.configTab)
    },
    taskResult() {
      this.showTaskResult = this.taskResult !== undefined
      setTimeout(() => { this.resetTaskResults() }, 6000)
    }
  },
  methods: {
    cancelNewTemplate() {
      this.$router.push({ name: "CaseConfigOverview" })
    },
    resetTaskResults() {
      this.showTaskResult = false
      if (this.shouldRefresh && !this.taskResult.error) {
        this.$router.push({ name: "CaseConfigOverview" })
      }
      this.shouldRefresh = false
    },
    saveCaseType() {
      if (this.skipSaveWarning) {
        this.performSave()
      } else {
        if (this.shouldUpdateExisting) {
          this.dialogSaveAll = true
        } else {
          this.dialogSaveThis = true
        }
      }
    },
    async createCaseType() {
      const data = {
        name: this.caseTypeUpdates.summary.name ? this.caseTypeUpdates.summary.name : this.caseType.name,
        description: this.caseTypeUpdates.summary.description ? this.caseTypeUpdates.summary.description : this.caseType.description,
        coreTemplate: this.caseTypeUpdates.coreTemplate ? this.caseTypeUpdates.summary.coreTemplate : this.caseType.coreTemplate,
        schema: this.caseTypeUpdates.summary.schema ? this.caseTypeUpdates.summary.schema : this.caseType.currentSchema,
        iconSet: this.caseTypeUpdates.summary.iconSet ? this.caseTypeUpdates.summary.iconSet : this.caseType.iconSet,
        iconCode: this.caseTypeUpdates.summary.iconCode ? this.caseTypeUpdates.summary.iconCode : this.caseType.iconCode
      }
      const success = await this.$store.dispatch("createCaseType", data)
      if (success) {
        this.$router.push({ name: "CaseConfigOverview" })
      }
    },
    async performSave() {
      this.dialogSaveAll = false
      this.dialogSaveThis = false
      if (this.skipSaveWarning) { this.$store.dispatch("toggleSaveWarnings", this.skipSaveWarning) }
      if (this.caseTypeUpdates.summary) {
        const data = {
          name: this.caseTypeUpdates.summary.name ? this.caseTypeUpdates.summary.name : this.caseType.name,
          description: this.caseTypeUpdates.summary.description ? this.caseTypeUpdates.summary.description : this.caseType.description,
          uniqueIdentifierField: this.caseTypeUpdates.summary.uniqueIdentifierField ? this.caseTypeUpdates.summary.uniqueIdentifierField : this.caseType.uniqueIdentifierField,
          coreTemplate: !Helpers.isNull(this.caseTypeUpdates.summary.coreTemplate) ? this.caseTypeUpdates.summary.coreTemplate : this.caseType.coreTemplate,
          displayName: this.caseTypeUpdates.summary.displayName ? this.caseTypeUpdates.summary.displayName : this.caseType.displayName,
          schema: this.caseTypeUpdates.summary.currentSchema ? this.caseTypeUpdates.summary.currentSchema : this.caseType.currentSchema,
          iconSet: this.caseTypeUpdates.summary.iconSet ? this.caseTypeUpdates.summary.iconSet : this.caseType.iconSet,
          iconCode: this.caseTypeUpdates.summary.iconCode ? this.caseTypeUpdates.summary.iconCode : this.caseType.iconCode
        }
        await this.$store.dispatch("updateCaseType", { id: parseInt(this.caseTypeId), caseType: data })
      }
      if (this.newDisplayFields && this.newDisplayFields.length > 0) {
        let index = 0
        this.newDisplayFields.forEach(displayField => {
          displayField.position = index
          if (displayField.id > 0) {
            this.$store.dispatch("updateSummaryDisplayField", displayField)
          } else {
            this.$store.dispatch("createSummaryDisplayField", { id: parseInt(this.caseTypeId), fieldset: displayField.fieldset, fieldName: displayField.fieldName, position: displayField.position })
          }
          index++
        })
        this.$store.dispatch("summariseCases", parseInt(this.caseTypeId))
        this.$store.dispatch('reloadCaseTypes')
      }
      this.hasChanged = false
    },
    handleSummaryFieldUpdates(displayFields) {
      if (displayFields) {
        this.hasChanged = true
        this.newDisplayFields = displayFields
      }
    },
    handleSummaryUpdate(data) {
      if (data) {
        this.hasChanged = true
        if (!this.caseTypeUpdates.summary) {
          this.caseTypeUpdates.summary = {}
        }
        this.caseTypeUpdates.summary[data.key] = data.value
      }
    },
    handleUpdate(data) {
      if (data) {
        this.hasChanged = true
        this.caseTypeUpdates[data.key] = data.value
      }
    },
    handleClick() {
      this.localUpdate = true
      // DO NOT MERGE, for KS access to tabs
      // const case_type_id = this.caseType.id || 'new'
      // const config_tab = item.name // gets item from handleClick vars
      // this.$router.push({ name: 'CaseConfig',  params: {case_type_id, config_tab}})
    },
    handleRouteChange(route) {
      if (route && !this.localUpdate) {
        switch (route.toLowerCase()) {
          case "summary":
            this.configModel = 0
            break
          case "schema":
            this.configModel = 1
            break
          case "tasks":
            this.configModel = 2
            break
          case "status":
            this.configModel = 3
            break
          case "relationships":
            this.configModel = 4
            break
          case "scripts":
            this.configModel = 5
            break
          case "emails":
            this.configModel = 6
            break
          case "permissions":
            this.configModel = 7
            break
          case "documents":
            this.configModel = 8
            break
          default:
            this.configModel = 0
        }
        this.localUpdate = false
      }
    },
    async deleteCaseType() {
      this.dialogDelete = false
      this.shouldRefresh = true
      const success = await this.$store.dispatch("deleteCaseType", parseInt(this.caseTypeId))
      if (success) {
        this.$router.push({ name: "CaseConfigOverview" })
      }
    },
    toggleReindexCasesDialog(state) {
      if (state && !this.isAppAdmin) return
      this.showReindexCasesDialog = state
    },
    async reindexCases() {
      if (!this.isAppAdmin) return
      await this.$store.dispatch("performReindexCaseType", {
        caseTypeId: parseInt(this.caseTypeId),
        dropExistingIndex: true
      })
      this.toggleReindexCasesDialog(false)
    },
    toggleReindexDocumentsDialog(state) {
      if (state && !this.isAppAdmin) return
      this.showReindexDocumentsDialog = state
    },
    async reindexDocuments() {
      if (!this.isAppAdmin) return
      await this.$store.dispatch("performReindexDocuments", {
        caseTypeId: parseInt(this.caseTypeId),
        dropExistingIndex: true
      })
      this.toggleReindexDocumentsDialog(false)
    }
  }
}
</script>

<style>
.accordion-parent .v-expansion-panel__header__icon {
  position: absolute;
  left: 20px;
  top: 14px;
}

.accordion-parent .accordion-child .v-expansion-panel__header {
  padding: 4px 24px !important;
  min-height: 20px;
}

.accordion-parent .accordion-child .v-expansion-panel__header__icon {
  top: 7px;
}

.white-box-field .v-input__slot {
  background: white !important;
}
</style>
